/**
 * Transform order data to the format expected by the address validation API
 * @param {Object} order - The order object containing order.order with billing_address and shipping_address
 * @returns {Object} Transformed object with order_meta structure for validation API
 */
export const transformOrderForAddressValidation = (order) => {
  const { billing_address, shipping_address } = order.order;

  const transformAddress = (addr) => ({
    name: addr.last_name || addr.first_name || '',
    address1: addr.address1 || '',
    address2: addr.address2 || '',
    city: addr.city || '',
    province: addr.province || '',
    country: addr.country || '',
    zip: addr.zip || '',
    phone: addr.phone || ''
  });

  return {
    order_meta: {
      shipping_address: transformAddress(shipping_address),
      billing_address: transformAddress(billing_address)
    }
  };
};

/**
 * Format address validation errors for display
 * @param {Object} details - Validation details object containing shipping_address and billing_address errors
 * @returns {Array} Array of formatted error objects
 */
export const formatAddressValidationErrors = (details) => {
  if (!details) return null;

  const errors = [];

  // Process shipping_address errors
  if (details.shipping_address) {
    Object.entries(details.shipping_address).forEach(([field, fieldData]) => {
      const fieldLabel = field === 'address1' ? 'Address Line 1' :
        field === 'address2' ? 'Address Line 2' :
          field === 'name' ? 'Name' :
            field === 'city' ? 'City' :
              field === 'province' ? 'Province' : field;

      fieldData.issues.forEach(issue => {
        errors.push({
          location: 'Shipping Address',
          field: fieldLabel,
          type: issue.description,
          sample: issue.sample,
          count: issue.count
        });
      });
    });
  }

  return errors;
};
